import {ValueAndLabelModel} from '../../../../model/valueAndLabel.model';
import {SummaryModel} from '../../../../entity/summary.model';
import {PermissionsModel} from '../../../../entity/permissions.model';

export class LovValueSummary extends ValueAndLabelModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    parentLabel: string;
    parentValue: string;
    index: number;
    lovListName: string;
    param: string;
}
